/* eslint-disable import/prefer-default-export */
/* eslint-disable no-console */
const removeHTML = (inputString = '') => {
  if (typeof inputString === 'string') {
    return inputString.replace(/<[^>]*>/g, '');
  }
  console.warn('removeHTML: Expected a string, got', typeof inputString);
  return '';
};

const isValidTextField = (string) => removeHTML(string).trim().length > 0;

export { removeHTML, isValidTextField };
